module.exports = __webpack_public_path__ + "4360fbeabe9a1b1db249eb303c2d6bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_130.jpg
// module id = 1696
// module chunks = 5